// トップスライダーの起動 // Launch the top slider
jQuery(function($) {

	if ( $('.js-slider').length > 0 ) {
		const swiper = new Swiper('.js-slider .swiper', {
			slidesPerView: 3,
			paginationClickable: true,
			spaceBetween: 15,
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: '.swiper-scrollbar',
			},
			breakpoints: {
				1024: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 2,
				},
				375: {
					slidesPerView: 1,
					spaceBetween: 26
				}
			}
		});
	}

	if ( $('.js-slide-works').length > 0 ) {
		const swiperWork = new Swiper('.js-slide-works .swiper', {
			slidesPerView: 1,
			paginationClickable: true,
			spaceBetween: 90,
			centeredSlides: true,
			loop: false,

			navigation: {
				nextEl: '.work-button-next',
				prevEl: '.work-button-prev',
			},

			breakpoints: {
				// 1200px以上の場合
				1366: {
					slidesPerView: 1.5,
				}
			}
		});
	}

});



//video遅延
document.addEventListener("DOMContentLoaded", function() {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazyVideo"));
  
	if ("IntersectionObserver" in window) {
	  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(video) {
		  if (video.isIntersecting) {
			for (var source in video.target.children) {
			  var videoSource = video.target.children[source];
			  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src;
			  }
			}
  
			video.target.load();
			video.target.classList.remove("lazy");
			lazyVideoObserver.unobserve(video.target);
		  }
		});
	  });
  
	  lazyVideos.forEach(function(lazyVideo) {
		lazyVideoObserver.observe(lazyVideo);
	  });
	}
  });